<template>
  <div class="section-main__warp firePatrol__wrap">
    <ioc-table
      ref="crud"
      :data="tableData"
      :option="option"
      :page="page"
      @search-change="handleSearchChange"
      @search-reset="handleSearchReset"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <template slot="exceptionNum" slot-scope="scope">
        <span
          @click="handleExcepTion(scope.row)"
          style="color: #f56c6c; cursor: pointer"
        >
          {{ scope.row.exceptionNum }}
        </span>
      </template>
      <template slot="resovleNum" slot-scope="scope">
        <span
          @click="handleResolve(scope.row)"
          style="color: rgba(0, 194, 151, 1); cursor: pointer"
        >
          {{ scope.row.resovleNum }}
        </span>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-Detail"
            @click="handleView(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
      </template>
    </ioc-table>
    <countDetail @handleUpdate="getList" ref="refCountDetail" />
  </div>
</template>
  
  <script>
import { api } from "../api";
import countDetail from "../components/countDetail";
import tableOption from "../config/count";
import utils from "@src/common/utils";
export default {
  components: {
    countDetail,
  },
  data() {
    return {
      option: tableOption(this),
      tableData: [],
      searchForm: {},
      firePatrolCode: "",
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
    };
  },
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    handleUpdate() {
      this.getList();
    },
    handleSearchChange(param) {
      console.log(param);
      this.searchForm = { ...param };
      this.getList();
    },
    handleSearchReset() {
      this.searchForm = {};
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    getList() {
      let params = {
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        ...this.searchForm,
      };
      if (this.searchForm.createTime && this.searchForm.createTime.length > 0) {
        params.beginTime = this.searchForm.createTime[0];
        params.endTime = this.searchForm.createTime[1];
      }
      this.$fetch(api.getFirePatrolRecord, params).then((response) => {
        if (response.success) {
          this.tableData = response.returnObj.list;
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent || "获取巡检统计列表失败");
        }
      });
    },
    handleView(row) {
      this.getDetail(row).then((res) => {
        this.$refs.refCountDetail.dialogVisible = true;
        this.$refs.refCountDetail.queryFlag = "";
        this.$refs.refCountDetail.option.column =
          this.$refs.refCountDetail.optionCopy.column.concat(res);
        this.$refs.refCountDetail.firePatrolCode = row.firePatrolCode;
        this.$refs.refCountDetail.getReset();
      });
    },
    getDetail(row, queryFlag) {
      let tableOption = [];
      let params = {
        firePatrolCode: row.firePatrolCode,
      };
      if (queryFlag) {
        params.queryFlag = queryFlag;
      }
      return new Promise((resolve) => {
        this.$fetch(api.detailFirePatrolItems, params).then((res) => {
          if (res.success) {
            tableOption = res.returnObj.firePatrolItemList.map((el) => {
              return {
                label: el.firePatrolItemName,
                prop: el.firePatrolItemCode,
              };
            });
          }
          resolve(tableOption);
        });
      });
    },
    handleResolve(row) {
      this.getDetail(row, "resovle").then((res) => {
        this.$refs.refCountDetail.dialogVisible = true;
        this.$refs.refCountDetail.option.column =
          this.$refs.refCountDetail.optionCopy.column.concat(res);
        this.$refs.refCountDetail.queryFlag = "resovle";
        this.$refs.refCountDetail.firePatrolCode = row.firePatrolCode;
        this.$refs.refCountDetail.getReset();
      });
    },
    handleExcepTion(row) {
      this.getDetail(row, "exception").then((res) => {
        this.$refs.refCountDetail.dialogVisible = true;
        this.$refs.refCountDetail.option.column =
          this.$refs.refCountDetail.optionCopy.column.concat(res);
        this.$refs.refCountDetail.queryFlag = "exception";
        this.$refs.refCountDetail.firePatrolCode = row.firePatrolCode;
        this.$refs.refCountDetail.getReset();
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.firePatrol {
  &__wrap {
    //
  }
}
</style>